import { useEffect, useMemo, useState } from "react";
import { Loader2, Search } from "lucide-react";
import { api, formatPrice } from "@/lib/api";
import { lugarLabel } from "@/components/closefriends/constants";

export const CloseFriendsFoods = ({ onOpen }) => {
  const [rows, setRows] = useState(null);
  const [q, setQ] = useState("");
  const [tipo, setTipo] = useState("");

  useEffect(() => { api.get("/admin/close-friends/alimentos").then(({ data }) => setRows(data)); }, []);

  const filtered = useMemo(() => {
    const t = q.trim().toLowerCase();
    return (rows || []).filter((r) => (!tipo || r.tipo === tipo) &&
      (!t || [r.marca, r.linea, r.nombre, r.lugar_nombre, r.zona].join(" ").toLowerCase().includes(t)));
  }, [rows, q, tipo]);

  if (!rows) return <div className="grid place-items-center py-16"><Loader2 className="w-7 h-7 animate-spin text-coral" /></div>;

  return (
    <div className="space-y-3" data-testid="cf-foods">
      <div className="flex flex-col sm:flex-row gap-2">
        <div className="relative flex-1">
          <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-moss" />
          <input data-testid="cf-foods-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar marca, línea, dueño o lugar"
            className="w-full h-11 pl-9 pr-3 rounded-xl bg-white border border-[#E3E7E2] text-sm focus:outline-none focus:ring-2 focus:ring-coral/40" />
        </div>
        <select data-testid="cf-foods-tipo" value={tipo} onChange={(e) => setTipo(e.target.value)} className="h-11 px-3 rounded-xl bg-white border border-[#E3E7E2] text-sm">
          <option value="">Perros y gatos</option><option value="perro">Perros</option><option value="gato">Gatos</option>
        </select>
      </div>
      <div className="overflow-x-auto rounded-2xl border border-[#E3E7E2] bg-white">
        <table className="w-full text-sm">
          <thead className="bg-peach/60 text-left text-xs uppercase tracking-wide text-charcoal">
            <tr>{["Marca / línea", "Mascota", "Dueño", "Kg", "Precio", "₡/kg", "Lugar", "Frecuencia", "Motivo"].map((h) => <th key={h} className="px-3 py-2.5 whitespace-nowrap">{h}</th>)}</tr>
          </thead>
          <tbody>
            {filtered.length === 0 && <tr><td colSpan={9} className="text-center text-muted-moss py-10">Sin registros</td></tr>}
            {filtered.map((r, i) => (
              <tr key={i} data-testid={`cf-food-row-${i}`} onClick={() => onOpen(r.close_friend_id)} className="border-t border-[#E3E7E2] hover:bg-cream-2 cursor-pointer">
                <td className="px-3 py-2.5"><b>{r.marca}</b><div className="text-xs text-muted-moss">{r.linea}</div></td>
                <td className="px-3 py-2.5 whitespace-nowrap">{r.nombre_mascota} <span className="text-xs text-muted-moss">({r.tipo}{r.cantidad > 1 ? ` ×${r.cantidad}` : ""})</span></td>
                <td className="px-3 py-2.5 whitespace-nowrap">{r.nombre}<div className="text-xs text-muted-moss">{r.zona}</div></td>
                <td className="px-3 py-2.5">{r.kg}</td>
                <td className="px-3 py-2.5 whitespace-nowrap">{formatPrice(r.precio)}</td>
                <td className="px-3 py-2.5 whitespace-nowrap">{formatPrice(r.precio_por_kg)}</td>
                <td className="px-3 py-2.5 whitespace-nowrap">{lugarLabel(r.lugar_compra)}<div className="text-xs text-muted-moss">{r.lugar_nombre}</div></td>
                <td className="px-3 py-2.5 whitespace-nowrap">{r.frecuencia}</td>
                <td className="px-3 py-2.5 min-w-[160px]">{r.motivo}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
